import React from 'react';
import { Navigate } from 'react-router-dom';


export default function ProtectedRoute({ children, userSession }) {
  // Check if user is logged in
  const isLoggedIn = userSession || localStorage.getItem("userKey");

  if (!isLoggedIn) {
    // User logged in नहीं है → home page पर redirect करो
    console.log("❌ Access Denied: User not logged in");
    return <Navigate to="/" replace />;
  }

  // User logged in है → protected page render करो
  console.log("✅ Access Granted: User logged in");
  return children;
}